import Loader from "../../../../components/Loader/Loader";
import React, {useEffect, useState} from "react";
import {useFetch} from "../../../../components/common/FetchProvider";

const DeleteConfirmModal = ({ showModal, setModalState, existingFormData, setExistingFormData, refreshData, type }) => {
    const fetchWrapper = useFetch();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleCancel = () => {
        setModalState(false);
        setExistingFormData({});
    }

    const closeModalOnSubmit = () => {
        refreshData();
        handleCancel();
    }

    useEffect(() => {
        setMessage("Tem a certeza que pretende apagar "+type+" com id "+existingFormData.id);
    }, [existingFormData, type]);

    const handleDelete = async () => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/${type}/${existingFormData.id}`;

            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                closeModalOnSubmit();
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    }

    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Delete confirm</h4>
                                </div>
                                <header className="relative flex items-center justify-between">
                                    <div className="text-xl font-bold pl-6 text-navy-700 dark:text-white">
                                        <p>{message}</p>
                                        <p className="text-red-500">Não poderá recuperar isso</p>
                                    </div>
                                </header>


                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
}

export default DeleteConfirmModal;
